import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";

export const ProductBasicTable = observer(() => {
  const {
    productManagement: { productDetail },
  } = useStores();
  return (
    <XTablePagination hidePagination>
      <TableHead>
        <TableRow>
          <TableCell>Mã hàng</TableCell>
          <TableCell>Tên hàng</TableCell>
          <TableCell>Tên giao dịch</TableCell>
          <TableCell>Mã vạch</TableCell>
          <TableCell>DVT</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>{productDetail?.code || ""}</TableCell>
          <TableCell>{productDetail?.name || ""}</TableCell>
          <TableCell>{productDetail?.customer?.dealingName || ""}</TableCell>
          <TableCell>{productDetail?.barcode || ""}</TableCell>
          <TableCell>{productDetail?.unitOfCalculation || ""}</TableCell>
        </TableRow>
      </TableBody>
    </XTablePagination>
  );
});
